module.exports = __webpack_public_path__ + "img/banner@2x.f144c4ae.png";